module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9_4.c0524339.png";